module.exports = "/_next/static/images/BuildHighPerformance-3@2x-428aad3d4da04c896a01db0e660543bd.webp";